import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { BottomNavigation, BottomNavigationAction } from "@mui/material";
import useStore from "../store/store";
import constants from "../utils/constants";

function NavbarButtons() {
  const [value, setValue] = useState("");
  const location = useLocation();
  const { setCurrObj } = useStore((state) => state);

  useEffect(() => {
    let currentPath = location.pathname;
    currentPath = currentPath.split("/").pop();
    if (
      currentPath === "changePassword" ||
      currentPath === "profile" ||
      currentPath === "users" ||
      currentPath === "about-us" ||
      currentPath === "stocks"
    ) {
      setValue("settings");
    } else if (currentPath === "chart") {
      setValue("");
    } else if (
      currentPath === "" ||
      currentPath === "trial-balance" ||
      currentPath.includes("id=")
    ) {
      setValue("accounts");
    } else if (currentPath.includes("bill")) {
      setValue("bills");
    } else setValue(currentPath);
  }, [location.pathname]);

  const handleChange = (event, newValue) => {
    setCurrObj(null);
    setValue(newValue);
  };

  const getColor = (str) => {
    return value === str ? constants.PRIMARY : "";
  };

  return (
    <BottomNavigation
      value={value}
      onChange={handleChange}
      style={{ paddingLeft: 8, paddingRight: 8 }}
    >
      <BottomNavigationAction
        sx={{
          color: getColor("accounts"),
        }}
        value="accounts"
        icon={<ion-icon name="book-outline" size="large"></ion-icon>}
        component={Link}
        to="/accounts"
      />
      <BottomNavigationAction
        sx={{
          color: getColor("transactions"),
        }}
        value="transactions"
        icon={<ion-icon name="swap-vertical-outline" size="large"></ion-icon>}
        component={Link}
        to="/transactions"
      />
      <BottomNavigationAction
        sx={{
          color: getColor("bills"),
        }}
        value="bills"
        icon={<ion-icon name="document-text-outline" size="large"></ion-icon>}
        component={Link}
        to="/bills"
      />
      <BottomNavigationAction
        sx={{
          color: getColor("settings"),
        }}
        value="settings"
        icon={<ion-icon name="settings-outline" size="large"></ion-icon>}
        component={Link}
        to="/settings"
      />
    </BottomNavigation>
  );
}

export default NavbarButtons;
